// extracted by mini-css-extract-plugin
export var actions = "_3-0";
export var actionsContainer = "_3-7";
export var border = "_3-1";
export var childFullHeight = "_3-g";
export var collapse = "_3-2";
export var content = "_3-b";
export var contentChild = "_3-f";
export var fullscreen = "_3-d";
export var hasLeftRadius = "_3-l";
export var headerContainer = "_3-3";
export var headerRow = "_3-5";
export var hidePadding = "_3-c";
export var navCollapsedGap = "_3-m";
export var noScrollX = "_3-n";
export var noScrollY = "_3-o";
export var noTopPadding = "_3-j";
export var optOutTopPadding = "_3-e";
export var pageMain = "_3-k";
export var pageOuter = "_3-h";
export var pagePadding = "_3-8";
export var pageScroll = "_3-9";
export var profile = "_3-p";
export var profileContainer = "_3-q";
export var profileImage = "_3-r";
export var profileMain = "_3-s";
export var profileSubtitle = "_3-u";
export var profileTitle = "_3-t";
export var settingsSurface = "_3-a";
export var showLeftPadding = "_3-i";
export var tabsPortalSlot = "_3-6";
export var tabsWrapper = "_3-4";
export var title = "_3-v";